import Constants, {ScreenOrientation} from '../globals/Constants';

const getOrientation = (): string => {
   if (window.innerWidth > window.innerHeight + Constants.mobileOrientationBufferZone) {
      return ScreenOrientation.landscape;
   } else {
      return ScreenOrientation.portrait;
   }
};

const isMobileWidth = (): boolean => {
   if (window.outerWidth < Constants.mobileWidthBreakpoint) {
      return true;
   } else {
      return false;
   }
};

export default {
   getOrientation,
   isMobileWidth
};